export const getClassName = (type, value) => {
    if (!value) return '';
    const prefix = `student-${type}-`;
    return prefix + value.toLowerCase().replace(/\//g, '-').replace(/ /g, '-');
};
